import { Schema } from '@core/data/dto/schema';
import { datetimeMomentToUTCDatetimeStr } from '@core/utils/moment';

export const DeliveryOrderQuoteRequestSchema = {
    location_id: {
        map: 'location',
        mapExport: (value: { id: string }) => value.id,
    },
    external_id: Schema.String,
    order_number: {
        map: 'orderReference',
    },
    requires_id: Schema.Boolean,
    requires_dropoff_signature: Schema.Boolean,
    order_type: Schema.Auto,
    tax: Schema.Number,
    tip: Schema.Number,
    total: Schema.Number,
    order_items: [Schema.Auto],
    customer_name: Schema.String,
    customer_phone: Schema.String,
    delivery_instruction: Schema.String,
    customer_address: Schema.String,
    pickup_at_ready: {
        map: 'pickupAtReady',
        mapExport: datetimeMomentToUTCDatetimeStr,
    },
    delivery_time_utc: {
        map: 'dropoffAtEta',
        mapExport: datetimeMomentToUTCDatetimeStr,
    },
    payment_methods: [Schema.String],
};